var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isDesktopTablet)?_c(_setup.EventCardDesktop,{attrs:{"preview-event":_vm.previewEvent}}):_c(_setup.EventCardMobile,{attrs:{"preview-event":_vm.previewEvent}})
}
var staticRenderFns = []

export { render, staticRenderFns }